module.exports = __webpack_public_path__ + "static/media/stepClean.f6ab8d9f.png";